import styled, { css } from "styled-components";

export const StatusTagButton = styled.button`
  width: 135px;
  height: 24px;
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  background: #fff;
  border: 1px solid #5f6567;
  color: #5f6567;
  outline: none;

  ${({ $type }) =>
    $type === "Enviar a Facturar" &&
    css`
      cursor: pointer;
      border: 1px solid #fd2415;
      color: #fd2415;

      &:hover {
        background: #fd2415;
        color: #fff;
        outline: none;
      }
      &:focus,
      &:active {
        outline: none;
      }
    `}

  ${({ $type }) =>
    $type === "Enviado a Facturar" &&
    css`
      border: none;
      background: rgba(204, 204, 204, 0.5);
      color: #5f6567;
    `}

  ${({ $type }) =>
    $type === "Error o Rechazado" &&
    css`
      border: none;
      background: #fd2415;
      color: #fff;
    `}

     &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PeriodoActualTitle = styled.h5`
  color: #293134;

  font-family: "Nunito";
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: 22px; /* 122.222% */
  letter-spacing: 0.6px;
  margin-bottom: 0px;
`;

export const TagButton = styled.button`
  background-color: #ffe0e0;
  color: #ff3b30;
  border: none;
  border-radius: 8px;
  padding: 2px 12px;
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
  outline: none;

  svg {
    margin-left: 6px;
    width: 16px;
    height: 16px;
    stroke-width: 2.2;
  }

  ${(props) =>
    !props.disabled &&
    `
    &:hover {
      background-color: #ff3b30;
      color: #fff;
    }
  `}

  &:focus,
  &:active {
    outline: none;
  }
`;

export const PeriodoActualContainer = styled.div`
  display: flex;
  height: 35px;
  padding: 8px 16px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #f7f7f7;
  width: fit-content;
`;

export const PeriodoActualFecha = styled.span`
  color: #293134;

  font-family: "Nunito";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24.778px; /* 141.667% */
  letter-spacing: 0.437px;
`;

export const PeriodoActualLabel = styled.span`
  color: #5f6567;
  font-family: "Nunito";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
